<template>
  <div id="Daxiaozhoushi">
    <div class="tr-header">
      <p class="title">大小走势</p>
      <div class="handles" v-if="betType != 'xyrb'">
        <span
          @click="handleChecked('today', '0')"
          :class="{'checked': checked === '0'}"
          class="handle"
        >今天</span>
        <span
          @click="handleChecked('yesterday', '1')"
          :class="{'checked': checked === '1'}"
          class="handle"
        >昨天</span>
        <span
          @click="handleChecked('beforeYesterday', '2')"
          :class="{'checked': checked === '2'}"
          class="handle"
        >前天</span>
        <span
          @click="handleChecked('30', '3')"
          :class="{'checked': checked === '3'}"
          class="handle"
        >最近 30 期</span>
        <span
          @click="handleChecked('60', '4')"
          :class="{'checked': checked === '4'}"
          class="handle"
        >最近 60 期</span>
        <span
          @click="handleChecked('90', '5')"
          :class="{'checked': checked === '5'}"
          class="handle"
        >最近 90 期</span>
      </div>
    </div>
    <div class="tr-table-container">
      <div class="check_box">
        <span>标注选择:</span>
        <CheckboxGroup v-model="showList" @on-change="checkAllGroupChange">
          <Checkbox label="yilou">遗漏</Checkbox>
          <Checkbox label="zhexian">折线</Checkbox>
          <Checkbox label="yifen">遗漏分成</Checkbox>
        </CheckboxGroup>
      </div>
    </div>
    <div class="tr-table-container">
      <Table width="100%" :columns="columns" :loading="isLoading" :data="dataSource" border></Table>
      <div>
        <p>遗漏：自上期开出到本期间隔的期数。</p>
        <p>遗漏分层：将当期遗漏标注出来。</p>
      </div>
    </div>
  </div>
</template>
<script>
import columns from "./columns";
import dayjs from "dayjs";
import format from "../../../helpers/format.js";

export default {
  name: "Daxiaozhoushi",
  data() {
    return {
      showList: ["yilou", "zhexian"],
      columns: [],
      pageSize: 30,
      dataSource: [],
      checked: "3",
      isLoading: false,
      startDate: ""
    };
  },
  computed: {
    betType() {
      return this.$route.params.betType;
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler() {
        this.getDate();
      }
    }
  },
  methods: {
    reset(data) {
      this.columns = columns(this.betType, data, this.ballIndex).list(this);
    },
    handleChecked(agt, index) {
      this.startDate = "";
      this.pageSize = "";
      this.checked = index;
      if (agt == "today") {
        this.startDate = dayjs().format("YYYY-MM-DD");
      } else if (agt == "yesterday") {
        this.startDate = dayjs()
          .add(-1, "day")
          .format("YYYY-MM-DD");
      } else if (agt == "beforeYesterday") {
        this.startDate = dayjs()
          .add(-2, "day")
          .format("YYYY-MM-DD");
      } else if (agt == "30") {
        this.pageSize = 30;
      } else if (agt == "60") {
        this.pageSize = 60;
      } else if (agt == "90") {
        this.pageSize = 90;
      }
      this.getDate();
    },
    async getDate() {
      let req = {
        gameType: this.$route.params.gameType,
        num: this.pageSize,
        date: this.startDate
      };
      this.isLoading = true;
      let res = await this.$http.post("/queryKcReportByIssue.do", req);
      if (res.data.returnCode == "0000") {
        this.isLoading = false;
        var arr;
        if (this.betType == "ssc") {
          arr = format.formatSscDingwei(res.data.returnList, this.ballIndex);
        } else {
          arr = format.formatKsDingwei(res.data.returnList, this.ballIndex);
        }
        this.dataSource = arr;
        this.formatNum();

        this.reset(arr);
        this.$nextTick(() => {
          // window.scrollTo(0, 0);
          var canvas = document.querySelector(".cvs_container");
          let table = document.querySelector(".ivu-table-body");
          if (canvas) {
            table.removeChild(canvas);
          }
          this.createCanvas();
        });
      } else {
        this.$Message.error(res.data.returnMessage);
      }
    },
    formatNum() {
      var source = this.dataSource;
      for (let i = 0; i < source.length; i++) {
        var o = {};
        const e = source[i].ballList;
        for (let j = 0; j < e.length; j++) {
          const n = e[j];
          var keys = Object.keys(o);

          if (!keys.includes(n)) {
            o[n] = 1;
          } else {
            o[n] += 1;
          }
        }
        source[i].numDistribute = o;
      }
    },
    checkAllGroupChange() {
      var lostList = document.querySelectorAll(".lost_info");
      var canvas = document.querySelector(".cvs_container");
      var divide = document.querySelectorAll(".divide_lost_info");
      for (let i = 0; i < divide.length; i++) {
        const e = divide[i];
        e.parentNode.parentNode.classList.remove("lost_active");
      }
      if (!this.showList.includes("yilou")) {
        for (let i = 0; i < lostList.length; i++) {
          const e = lostList[i];
          e.style.display = "none";
        }
      } else {
        for (let i = 0; i < lostList.length; i++) {
          const e = lostList[i];
          e.style.display = "inline-block";
        }
      }
      if (!this.showList.includes("zhexian")) {
        canvas.style.display = "none";
      } else {
        canvas.style.display = "inline-block";
      }
      if (this.showList.includes("yifen")) {
        for (let i = 0; i < divide.length; i++) {
          const e = divide[i];
          e.parentNode.parentNode.classList.add("lost_active");
        }
      } else {
        for (let i = 0; i < divide.length; i++) {
          const e = divide[i];
          e.parentNode.parentNode.classList.remove("lost_active");
        }
      }
    },
    createCanvas() {
      let table = document.querySelector(".ivu-table-body");
      let tablePos = table.getBoundingClientRect();
      let tableleft = tablePos.left;
      let tabletop = tablePos.top;
      //设置画布
      let cvs = document.createElement("canvas");
      cvs.style.marginTop = -table.offsetHeight + "px";
      cvs.className = "cvs_container";
      cvs.height = table.offsetHeight; // 表格的高度等同画布高度
      cvs.width = table.scrollWidth; // 表格的高度等同画布高度

      if (this.betType == "ks") {
        var length = 2;
        var redList = document.querySelectorAll(".red");
      } else {
        var length = 9;
        var redList = document.querySelectorAll(".hp_red");
      }
      let redLength = redList.length; // 中奖号码球数 150

      let canvasArr = []; // 画笔坐标系
      for (let i = 0; i < length; i++) {
        canvasArr[i] = new Array();
        // console.log(i + 1, "iiii");
        // for (let j = 0; j < this.pageSize; j++) {
        for (let j = 0; j < this.dataSource.length; j++) {
          var num = i + length * j;
          let dom = redList[num];
          let pos = dom.getBoundingClientRect();
          let left = pos.left + dom.offsetHeight / 2;
          let top = pos.top + dom.offsetWidth / 2;
          let a = { left: left - tableleft, top: top - tabletop - 15 };
          canvasArr[i].push(a);
        }
      }
      for (let i = 0; i < canvasArr.length; i++) {
        let colors = {
          0: "#fba75e",
          1: "#1fa6e8",
          2: "#0abe02",
          3: "#8485fb",
          4: "#46bd94",
          5: "#e16baa",
          6: "#f2b653",
          7: "#628ef3",
          // 8: "#5ec642",
          8: "#f66d6d"
        };
        let color = colors[i];
        let cxt = cvs.getContext("2d"); // 画笔
        cxt.strokeStyle = color; // 颜色
        cxt.beginPath();
        let it = canvasArr[i];
        if (it.length > 0) {
          cxt.moveTo(it[0].left, it[0].top);
          for (let j = 0; j < it.length; j++) {
            cxt.lineTo(it[j].left, it[j].top);
            cxt.stroke();
          }
        }
      }
      table.append(cvs); // 将绘画好的走势图接入表格dom树
    }
  }
};
</script>
<style lang="less" scoped>
@import url("./index.less");
</style>



// WEBPACK FOOTER //
// src/pages/Trend/Daxiaozhoushi/index.vue